module.exports = "/_next/static/images/ScoreMeter2@2x-72b5ea0b2fca7397eb4d3ab58a5e13c4.webp";